import logo from "./logo.svg";
import "./App.css";
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'
import Routes from "./pages/Router/Routes";
import { Provider } from "react-redux";
import { store } from "./app/store";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";
import {
  DicomDownloadProvider,
  useDicomDownloadContext,
} from "./utilities/DicomDownloadContext";
import { DownloadProgressPanel } from "./utilities/useDicomDownload";

let persistor = persistStore(store);

// Inner wrapper needed so we can consume the context inside the provider
function AppWithPanel() {
  const { downloads, removeDownload } = useDicomDownloadContext();
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Routes />
          <DownloadProgressPanel
            downloads={downloads}
            removeDownload={removeDownload}
          />
        </PersistGate>
      </Provider>
    </>
  );
}

function App() {
  return (
    <DicomDownloadProvider>
      <AppWithPanel />
    </DicomDownloadProvider>
  );
}

export default App;
